var PaymentProviderBase = (function (CheckoutApiModel, PromiseUtil) {

	var PaymentProviderBase = CheckoutApiModel.extend({

        type: 'None',
        paymentOption: 'None',
		_supportedTypes: [],
		_supportedOrderTypes: [],
        _supportedProviderType: null,

		prepayment: function () {
			return PromiseUtil.resolved();
		},

		complete: function (method) {
			return PromiseUtil.resolved();
		},

		tryComplete: function (data) {
			return PromiseUtil.rejected();
		},

		ready: function (cb) {
			cb();
		},

        isApplicable: function (method) {
            var result = false;
            if (method) {
                if (!this._supportedProviderType || !method.ProviderType ||
                    this._supportedProviderType.toLowerCase() === method.ProviderType.toLowerCase()) {
                    result =_.contains(this._supportedTypes, method.PaymentType) || _.contains(this._supportedOrderTypes, method.OrderPaymentType);
                }
            }
            return result;
        }
	});

	return PaymentProviderBase;
})(CheckoutApiModel, PromiseUtil);
